export const NOTIFICATION_PREFERENCE_CHANNELS = ['email', 'sms', 'push', 'voice', 'in_app'];

export function notificationPreferenceChannels(workflow) {
    if (workflow?.eventType === 'staff.mirror_health') return ['in_app', 'email'];
    if (workflow?.eventType === 'staff.inbound_message') return ['in_app', 'email', 'push', 'sms'];
    // Migration 285: client event request alerts go by push, email, both, or the in-app bell only.
    if (workflow?.eventType === 'staff.event_request_new' || workflow?.eventType === 'staff.event_request_waiting'
        || workflow?.eventType === 'staff.event_flight_change' || workflow?.eventType === 'staff.event_ride_change') return ['email', 'push', 'in_app'];
    return NOTIFICATION_PREFERENCE_CHANNELS;
}

export function normalizeNotificationWorkflows(workflows = []) {
    return workflows
        .filter((workflow) => workflow?.is_active !== false)
        .map((workflow) => ({
            workflowKey: workflow.workflow_key,
            eventType: workflow.event_type,
            displayName: workflow.display_name || workflow.event_type,
            factoryChannels: notificationPreferenceChannels({ eventType: workflow.event_type }).filter((channel) => (
                Array.isArray(workflow.default_channels) && workflow.default_channels.includes(channel)
            )),
        }))
        .sort((left, right) => left.displayName.localeCompare(right.displayName));
}

export function buildOverrideMap(overrides = []) {
    return overrides.reduce((map, override) => {
        if (
            override?.event_type
            && NOTIFICATION_PREFERENCE_CHANNELS.includes(override.channel)
            && typeof override.enabled === 'boolean'
        ) {
            map[`${override.event_type}:${override.channel}`] = override.enabled;
        }
        return map;
    }, {});
}

export function getEffectiveChannels(workflow, overrides = {}) {
    return notificationPreferenceChannels(workflow).filter((channel) => {
        const key = `${workflow.eventType}:${channel}`;
        if (Object.prototype.hasOwnProperty.call(overrides, key)) {
            return overrides[key] === true;
        }
        return workflow.factoryChannels.includes(channel);
    });
}

export function buildNotificationDefaultsPayload(channels = []) {
    return NOTIFICATION_PREFERENCE_CHANNELS.filter((channel) => channels.includes(channel));
}

export function shouldShowSeniorChannelNudge(workflow, channels = [], seniorAccountCount = 0) {
    return (
        seniorAccountCount > 0
        && workflow?.eventType?.startsWith('client.')
        && channels.includes('push')
        && !channels.includes('sms')
        && !channels.includes('voice')
    );
}
